import { useCallback, useEffect, useMemo, useState } from 'react';

import {
    Channel,
    Envs,
    MenuInitializer,
    ServerSessionSync,
    useChannelContext,
    useEnvContext,
    useMenuStore,
    useServerTime,
} from 'scbk-services';

//메뉴정보

import devMenu from '../../config/menu/menu-config.dev.xml?raw';
import prdMenu from '../../config/menu/menu-config.prd.xml?raw';
import sitemap from '../../config/menu/sitemap.xml?raw';
import { AppInitContext } from '../providers/AppInitProvider';

import { EmptyChannelInitializer } from './EmptyChannelInitializer';
import { InternetBankingInitializer } from './InternetBankingInitializer';
import { MobileBankingInitializer } from './MobileBankingInitializer';
import { MobileWebInitializer } from './MobileWebInitializer';

/**
 *
 */
interface AppContextInitializerProps {
    children?: React.ReactNode;
}

/**
 * 앱 초기화 처리 컴포넌트
 * @returns
 */
const AppContextInitializer: React.FC<AppContextInitializerProps> = ({ children }) => {
    const [initialized, setInitialized] = useState<boolean>(false);
    const { channel } = useChannelContext();
    const { getEnv } = useEnvContext();
    const menuLoad = useMenuStore((state) => state.load);
    const menuInit = useMenuStore((state) => state.initialized);

    //*******************************
    // useQuery staleTime 을 0으로 설정,
    // 컴포넌트 마운트 시 서버시간을 동기화하도록 처리
    //*******************************
    //서버시간 동기화 처리
    useServerTime();

    /**
     * 앱 초기화 컨텍스트 Props 획득
     */
    const contextValue = useMemo(() => {
        return {
            initialized,
            setInitialized,
        };
    }, [initialized, setInitialized]);

    /**
     * 채널별 초기화 컴포넌트를 가져온다.
     */
    const AppInitializer = useMemo(() => {
        if (channel === Channel.IB) return InternetBankingInitializer;
        if (channel === Channel.MB) return MobileBankingInitializer;
        if (channel === Channel.MW) return MobileWebInitializer;
        return EmptyChannelInitializer;
    }, [channel]);

    /**
     * 채널별 메뉴 로드
     */
    const onMenuInitialized = useCallback(async () => {
        const isProd = getEnv() === Envs.PROD || getEnv() === Envs.UAT;

        console.log('### menu channel', channel, ', isProd', isProd);
        //메뉴정보 로드
        await menuLoad(channel as string, isProd ? prdMenu : devMenu, sitemap);
        // TODO: 환경별 수정 필요

        //서비스 이용시간은 process-api 서버에서 관리
        //await serviceTimeLoad(serviceTimeXml);
    }, [channel]);

    useEffect(() => {
        console.log('### AppContextInitializer MOUNT');
        return () => {
            console.log('### AppContextInitializer UNMOUNT');
        };
    }, []);

    useEffect(() => {
        console.log('### AppContextInitializer menu init ', menuInit);
    }, [menuInit]);

    return (
        <AppInitContext.Provider value={contextValue}>
            <ServerSessionSync initialized={initialized}>
                <AppInitializer>
                    <MenuInitializer initialized={initialized} onInit={onMenuInitialized}>
                        {children}
                    </MenuInitializer>
                </AppInitializer>
            </ServerSessionSync>
        </AppInitContext.Provider>
    );
};

export { AppContextInitializer };
